<template>
  <div class="background-image-controller">
    <!-- <div class="fullscreen-row">
      <div
        class="col-sm-12 mx-auto text-center section-title-wrapper splash-s splash-container d-flex"
        style="padding-top: 30px;"
      >
        <h1 class="white h1-larger">LOCATION</h1>
      </div>
    </div> -->
    <div id="map" class="contact-section py-6">
      <!-- <div class="g-map-custom">
        <template>
          <div>
            <gmap-map
              :center="center"
              :zoom="15"
              style="width: '300px'; height: 520px"
              class="gmap_canvas"
              :options="mapStyle"
            >
              <gmap-marker
                :position="markers.position"
                :clickable="true"
                :draggable="false"
                :icon="{ url: require('../../../public/static/img/custom_marker.png')}"
                @click="center=markers.position"
              ></gmap-marker>
            </gmap-map>
          </div>
        </template>
      </div> -->
      <div class="container">
        <div class="row row-parent">
          <div class="col-sm-12 col-md-10 col-lg-9 contact-block mx-auto box">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 contact-location">
                <div class="d-flex">
                  <div class="mr-4">
                    <i class="ion-ios-pin font-3x text-warning white"></i>
                  </div>
                  <div class>
                    <h4 class="mb-2 white">Kontakt</h4>
                    <div class="mr-4">Spittelauer Lände 45, 1090 Wien</div>
                    <div class="mr-4">esports@crossconnect.at</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 contact-contact">
                <div class="d-flex">
                  <div class="mr-4">
                    <i class="ion-ios-train font-3x text-warning white"></i>
                  </div>
                  <div class>
                    <h4 class="mb-2 white">Anfahrt</h4>
                    <span>Öffentlich erreicht ihr uns mit der U4 oder U6, der Straßenbahn Linie D sowie den Bussen 35A und 37A Station Spittelau. Mit dem Auto könnt ihr im Park&Ride Spittelau parken.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lat: 48.2338, lng: 16.3602 },
      mapStyle: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121"
              }
            ]
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121"
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a"
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c"
              }
            ]
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e"
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d"
              }
            ]
          }
        ]
      },
      markers: {
        position: { lat: 48.2338, lng: 16.3602 }
      }
    };
  }
};
</script>
<style scoped>
#map {
  padding-top: 0;
  padding-bottom: 0;
}

.text-warning {
  color: #02b6b6 !important;
}

.contact-block {
  border-radius: 0 !important;
}

.box {
  background-color: #e44f1d;
  color: white !important;
}
.white {
  color: white !important;
}

.background-image-controller {
  padding-top: 150px;
  background: black;
  background-image: url(/static/img/controller10l.png); /*was controller-l*/
  background-repeat: no-repeat;
  background-position: -10% -0%;
  background-size: 32%;
}

.fullscreen-row {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}

.fullscreen-row:before,
.fullscreen-row:after {
  display: table;
  content: " ";
}

.fullscreen-row:after {
  clear: both;
}

.p-larger {
  font-size: 1.75em !important;
}
.white {
  color: white !important;
}
.h1-larger {
  font-size: 4.5em;
}

.splash-s {
  background-image: url(/static/img/splash_location_red.png),
    url(/static/img/splash_location_blue.png);
  background-position: 60% 70%, 30% -150%;
  background-repeat: no-repeat;
  min-height: 200px;
}

.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 600px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash_location_red.png),
      url(/static/img/splash_location_blue.png);
    background-position: 80% 65%, 10% 80% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 100px, 130px;
    min-height: 200px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash_location_red.png),
      url(/static/img/splash_location_blue.png);
    background-position: 65% 65%, 25% 80% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 110px, 170px;
    min-height: 200px;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .h1-larger {
    font-size: 4.5em !important;
  }
  .row > div > .p-larger {
    font-size: 1.9em !important;
  }
  .fullscreen-row > .splash-s {
    background-image: url(/static/img/splash_location_red.png),
      url(/static/img/splash_location_blue.png);
    background-position: 70% 60%, 20% 74% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 120px, 170px;
    min-height: 200px;
  }
}
</style>
